import { render, staticRenderFns } from "./DeviceImageData.vue?vue&type=template&id=85de9ed0"
import script from "./DeviceImageData.vue?vue&type=script&lang=js"
export * from "./DeviceImageData.vue?vue&type=script&lang=js"
import style0 from "./DeviceImageData.vue?vue&type=style&index=0&id=85de9ed0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports